<template>
<span>
    <block :id="dataQa + '.address'"
           v-model="route"
           :focused="routeFocused"
           :type="'input'"
           :as-field="true"
           :step-fields-count="stepFieldsCount"
           :title="title || $trl('aw.address_address')"
           :state-id="stateId"
           :settings="settingsRoute"
           :show-required-mark="true"
           @blur="() => { routeFocused = false }"
           @focus="() => { routeFocused = true }"
           @finished="finished"/>

    <block v-if="showApt"
           :id="dataQa + '.apt'"
           v-model="apt"
           :focused="aptFocused"
           :as-field="true"
           :step-fields-count="stepFieldsCount"
           :type="'input'"
           :title="$trl('aw.address_apt')"
           :state-id="stateId"
           :settings="settingsApt"
           @blur="() => { aptFocused = false }"
           @focus="() => { aptFocused = true }"
           @finished="finished"/>

    <block :id="dataQa + '.locality'"
           v-model="locality"
           :focused="localityFocused"
           :as-field="true"
           :step-fields-count="stepFieldsCount"
           :type="'input'"
           :title="$trl('aw.address_locality')"
           :state-id="stateId"
           :settings="settingsLocality"
           @blur="() => { localityFocused = false }"
           @focus="() => { localityFocused = true }"
           @finished="finished"/>

    <block :id="dataQa + '.area'"
           v-model="administrative_area_level_1"
           :as-field="true"
           :step-fields-count="stepFieldsCount"
           :focused="areaFocused"
           :type="'combobox'"
           :title="$trl('aw.address_area')"
           :state-id="stateId"
           :settings="settingsArea"
           @blur="() => { areaFocused = false }"
           @focus="() => { areaFocused = true }"
           @finished="finished"/>

    <block :id="dataQa + '.zip'"
           v-model="postal_code"
           :as-field="true"
           :step-fields-count="stepFieldsCount"
           :focused="postalFocused"
           :type="'input'"
           :title="$trl('aw.address_zip')"
           :state-id="stateId"
           :settings="settingsPostalCode"
           @blur="() => { postalFocused = false }"
           @focus="() => { postalFocused = true }"
           @finished="finished"/>
</span>
</template>

<script>
/* eslint-disable @typescript-eslint/camelcase */

import '@/scss/blocks/error-message.scss';
import '@/scss/blocks/address.scss';

import { safeParse } from '@/utils/json';
import mapsMixin from '@/utils/mixins/maps';
import focusMixin from '@/utils/mixins/focus';

export default {
    mixins: [mapsMixin, focusMixin],
    props: {
        id: {},
        dataQa: {},
        value: {},
        stateId: {},
        required: {},
        adaptive: {},
        adaptiveArea: {
            default: true,
        },
        adaptiveStartArea: {},
        adaptiveEndArea: {},
        adaptivePostalCode: {
            default: true,
        },
        adaptiveStartPostalCode: {},
        adaptiveEndPostalCode: {},
        adaptiveStartApt: {},
        adaptiveEndApt: {},
        adaptiveApt: {},
        adaptiveStartRoute: {},
        adaptiveEndRoute: {},
        adaptiveRoute: {},
        adaptiveStartLocality: {},
        adaptiveEndLocality: {},
        adaptiveLocality: {},
        inputPatternApt: {},
        inputPatternRoute: {},
        inputPatternLocality: {},
        title: {},
        stepFieldsCount: {},
        showApt: {
            default: true,
        },
    },
    data () {
        let { postal_code, apt, route, administrative_area_level_1, locality } = safeParse(this.value || '{}');

        return {
            // eslint-disable-next-line camelcase
            postal_code: postal_code || '',
            apt: apt || '',
            route: route || '',
            // eslint-disable-next-line camelcase
            administrative_area_level_1: administrative_area_level_1 || '',
            locality: locality || '',
            inited: false,
            statesList: ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'],
            routeFocused: false,
            aptFocused: false,
            localityFocused: false,
            areaFocused: false,
            postalFocused: false,
        };
    },
    computed: {
        statesListOptions () {
            return this.statesList.map(state => {
                return {
                    id: state,
                    title: state,
                };
            });
        },
        settingsApt () {
            return {
                adaptiveStart: this.adaptiveStartApt,
                adaptiveEnd: this.adaptiveEndApt,
                adaptive: this.adaptiveApt === undefined ? this.adaptive : this.adaptiveApt,
                keyboard: 'text',
                inputPattern: this.inputPatternApt,
            };
        },
        settingsRoute () {
            return {
                adaptiveStart: this.adaptiveStartRoute,
                adaptiveEnd: this.adaptiveEndRoute,
                adaptive: this.adaptiveRoute === undefined ? this.adaptive : this.adaptiveRoute,
                keyboard: 'text',
                required: this.required,
                inputPattern: this.inputPatternRoute,

            };
        },
        settingsLocality () {
            return {
                adaptiveStart: this.adaptiveStartLocality,
                adaptiveEnd: this.adaptiveEndLocality,
                adaptive: this.adaptiveLocality === undefined ? this.adaptive : this.adaptiveLocality,
                keyboard: 'text',
                inputPattern: this.inputPatternLocality,
            };
        },
        settingsArea () {
            return {
                takeWidth: 6,
                adaptive: this.adaptiveArea === undefined ? this.adaptive : this.adaptiveArea,
                innerWrap: this.adaptiveLocality === undefined ? !this.adaptive : !this.adaptiveLocality,
                optionsSize: true,
                keyboard: 'text',
                suggest: true,
                values: this.statesListOptions,
                inputPattern: '[a-zA-Z]*',
                adaptiveStart: this.adaptiveStartArea,
                adaptiveEnd: this.adaptiveEndArea,
            };
        },
        settingsPostalCode () {
            return {
                takeWidth: 6,
                adaptive: this.adaptivePostalCode === undefined ? this.adaptive : this.adaptivePostalCode,
                innerWrap: this.adaptiveLocality === undefined ? !this.adaptive : !this.adaptiveLocality,
                size: 6,
                maxlength: 5,
                inputPattern: '\\d*',
                adaptiveStart: this.adaptiveStartPostalCode,
                adaptiveEnd: this.adaptiveEndPostalCode,
            };
        },
    },
    watch: {
        postal_code: 'setValue',
        apt: 'setValue',
        route: 'setValue',
        administrative_area_level_1: 'setValue',
        locality: 'setValue',

        routeFocused: 'checkFocus',
        aptFocused: 'checkFocus',
        localityFocused: 'checkFocus',
        areaFocused: 'checkFocus',
        postalFocused: 'checkFocus',

        maps: {
            handler () {
                if (this.maps.ready) {
                    this.$nextTick(this.init); // Delays for mount
                }
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        checkFocus () {
            if (this.routeFocused ||
                this.aptFocused ||
                this.localityFocused ||
                this.areaFocused ||
                this.postalFocused
            ) {
                this.$emit('focus');
            } else {
                this.$emit('blur');
            }
        },
        finished (id) {
            if (id === this.dataQa + '.address') {
                if (this.showApt) {
                    this.aptFocused = true;
                } else {
                    this.localityFocused = true;
                }
            } else if (id === this.dataQa + '.apt') {
                this.localityFocused = true;
            } else if (id === this.dataQa + '.locality') {
                this.areaFocused = true;
            } else if (id === this.dataQa + '.area') {
                this.postalFocused = true;
            } else if (id === this.dataQa + '.zip') {
                this.$emit('finished', this.id);
            }
        },
        focus_focus () {
            if (!(this.routeFocused ||
                this.aptFocused ||
                this.localityFocused ||
                this.areaFocused ||
                this.postalFocused)
            ) {
                this.routeFocused = true;
            }
        },
        setValue () {
            this.$emit('input', JSON.stringify({
                route: this.route,
                apt: this.apt,
                locality: this.locality,
                administrative_area_level_1: this.administrative_area_level_1,
                postal_code: this.postal_code,
            }));
        },
        init () {
            let componentForm = {
                route: 'long_name',
                locality: 'long_name',
                administrative_area_level_1: 'short_name',
                postal_code: 'short_name',
            };

            let autocomplete = new window.google.maps.places.Autocomplete(document.querySelector(`[data-qa="input.${this.dataQa}.address"]`), { types: ['geocode'] });
            autocomplete.setFields(['address_component']);
            autocomplete.setComponentRestrictions({ country: ['us'] });

            let fillInAddress = () => {
                let place = autocomplete.getPlace();

                if (!place.address_components) {
                    return;
                }

                let hasRoute = false;

                place.address_components.forEach(component => {
                    let addressType = component.types[0];

                    if (addressType === 'route') {
                        hasRoute = true;
                        let street = place.address_components.find(component => component.types[0] === 'street_number');
                        this.route = (street ? street.long_name + ' ' : '') + component[componentForm[addressType]];
                    } else if (componentForm[addressType]) {
                        this[addressType] = component[componentForm[addressType]];
                    }
                });

                if (!hasRoute) {
                    this.route = '';
                }
            };

            autocomplete.addListener('place_changed', fillInAddress);

            this.inited = true;
        },
    },
    components: {
        block: require('@/vue/block.vue').default,
    },
};
</script>
